// extracted by mini-css-extract-plugin
export const logo = "styles-module--logo--8iRxH";
export const btnLogin = "styles-module--btnLogin--PITyn";
export const dialog = "styles-module--dialog--JLFfn";
export const dialogContent = "styles-module--dialogContent--Lysp2";